import { useEffect } from 'react';

function useMobileNav() {
  useEffect(() => {
    const wrapper = document.getElementById('mobileNav');
    const firstElem = wrapper?.firstElementChild;
    const firstLinkElem = firstElem?.firstElementChild;
    if (firstLinkElem) {
      setTimeout(() => {
        firstLinkElem.scrollIntoView({ inline: 'center' });
      }, 0);
    }
  }, []);

  const onActive = (linkId) => {
    const currentLink = document.getElementById(linkId);

    if (currentLink) {
      setTimeout(() => {
        currentLink.scrollIntoView({ inline: 'center' });
      }, 0);
    }
  };

  return { onActive };
}

export default useMobileNav;
